import React from "react"
import { Button, Flex, Heading, LinkBox, LinkOverlay } from "@chakra-ui/react"
import Card from "../../common/components/Card"
import Rater from "react-rater"
import { getPopMediaThumb, getClimbImage } from "../../utilities/imageUtils"
import SocialImage from "../../common/components/SocialImage"
import ClimbGrade from "../../common/components/ClimbGrade"
import { Box } from "@chakra-ui/react"
import { VideoThumbnail } from "../../media/components/VideoThumbnail"
import NextLink from "next/link"
import { useRouter } from "next/router"

import styles from "./css/RouteCard.module.css"

const RouteCard = (props) => {
  const { route } = props
  const router = useRouter()

  const imageObj = getPopMediaThumb(route)
  const climbImage = !imageObj && getClimbImage({ climb: route, width: 400 })

  return (
    <LinkBox>
      <Card variant="link">
        {route.color && (
          <div
            className={styles["card-line"]}
            style={{ backgroundColor: route.color }}
          />
        )}
        <Box m={-5} mb={3} overflow="hidden" position={"relative"}>
          {imageObj ? (
            imageObj?.video ? (
              <Box
                overflow="hidden"
                borderTopRightRadius={10}
                borderTopLeftRadius={10}
                maxHeight={200}
                display="flex"
                alignItems="center"
              >
                <VideoThumbnail videoUrl={imageObj?.video} />
              </Box>
            ) : (
              <SocialImage isSmall imageObj={imageObj} width="100%" />
            )
          ) : null}

          {climbImage && (
            <>
              <Box
                overflow={"hidden"}
                position={"absolute"}
                top={0}
                left={0}
                right={0}
                bottom={0}
              >
                <img
                  style={{
                    maxHeight: 200,
                    objectFit: "cover",
                    filter: "blur(5px) brightness(0.5)",
                    transform: "scale(1.1)",
                  }}
                  src={climbImage}
                  width="100%"
                  alt="problem"
                />
              </Box>
              <img
                style={{
                  position: "relative",
                  maxHeight: 200,
                  objectFit: "contain",
                }}
                src={climbImage}
                width="100%"
                alt="problem"
              />
            </>
          )}
        </Box>
        <Box>
          <Flex align="center" justify="space-between">
            <Heading as="h4" size="md" variant="link">
              <NextLink passHref href={`/routes/${route.slug}`}>
                <LinkOverlay>{route.name}</LinkOverlay>
              </NextLink>
            </Heading>
            <Heading as="h4" size="md" variant="link">
              <ClimbGrade dotSize={30} climb={route} gym={route.gym} />
            </Heading>
          </Flex>
          {route.quality ? (
            <Rater
              interactive={false}
              className="react-rater--small react-rater"
              total={5}
              rating={route.quality}
            />
          ) : null}
          <Flex align="center" justify="space-between">
            <Heading mb={0} size="sm" as="h6">
              {route.totalAscents} {route.totalAscents === 1 ? "Send" : "Sends"}
            </Heading>
            <Button
              variant="primary"
              size="sm"
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                e.nativeEvent.stopImmediatePropagation()
                router.push("/create/send/routes/" + route.slug)
              }}
            >
              Sent
            </Button>
          </Flex>
        </Box>
      </Card>
    </LinkBox>
  )
}

export default RouteCard
